import React from 'react';

interface ConfirmAllPricesBannerProps {
  itemsCount: number;
  onConfirm: () => void;
  confirmingAll: boolean;
}

const ConfirmAllPricesBanner: React.FC<ConfirmAllPricesBannerProps> = ({
  itemsCount,
  onConfirm,
  confirmingAll,
}) => {
  return (
    <div className="mb-6">
      <div className="p-4 bg-yellow-500/10 border border-yellow-500/30 rounded-lg">
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-yellow-400 font-medium mb-1">
              Price Update Required for {itemsCount} Items
            </p>
            <p className="text-gray-300 text-sm">
              The prices for {itemsCount} items have changed. Please confirm all prices before proceeding.
            </p>
          </div>
          <button
            onClick={onConfirm}
            disabled={confirmingAll}
            className="ml-4 px-6 py-2 bg-yellow-600 text-white rounded-lg hover:bg-yellow-700 disabled:opacity-50 disabled:cursor-not-allowed text-sm font-medium whitespace-nowrap"
          >
            {confirmingAll ? (
              <span className="flex items-center gap-2">
                <svg className="animate-spin h-4 w-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Confirming...
              </span>
            ) : (
              'Confirm All Prices'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmAllPricesBanner;

